import React from 'react';
import AssetTable from '../components/AssetTable';

export default function BondsPage() {
  return <AssetTable type="bond" title="Anleihen" icon="fa-solid fa-file-contract" chartType="bond" />;
}
